import { render } from "./Referred.vue?vue&type=template&id=5a78fa1a"
import script from "./Referred.vue?vue&type=script&lang=js"
export * from "./Referred.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__